import { Transaction } from "@ctypes";

export type UpdateTransferModalProps = {
  item: Transaction;
  type?: ModalType;
};

export enum ModalType {
  Withdrawal = "withdrawal",
  Contribution = "contribution",
}
